import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-rep-acct-report',
  templateUrl: './rep-acct-report.component.html',
  styleUrls: ['./rep-acct-report.component.css']
})
export class RepAcctReportComponent implements OnInit {

  public menu_item_id = '25';
  private dp = [];
  total_payment = '0';

  displayedColumns = ['invoice_no', 'customer_name', 'net_total', 'payment_amount',
    'payment_method', 'invoice_date', 'deliver_date', 'name'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'from_date': new Date(), 'to_date': new Date(), 'payment_per': '', 'employee_no': '',
    'title': 'تقرير حساب المندوب'
  };

  rep_list = [];

  Rep_Acct_Report; Payment_Total; Payment_Msg; No_Customer;
  From_Date; To_Date; Rep_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Rep_Acct_Report').subscribe((res: string) => {
      this.Rep_Acct_Report = res;
    });
    this.model['title'] = this.Rep_Acct_Report;

    translate.get('Payment_Total').subscribe((res: string) => {
      this.Payment_Total = res;
    });

    translate.get('Payment_Msg').subscribe((res: string) => {
      this.Payment_Msg = res;
    });

    translate.get('No_Customer').subscribe((res: string) => {
      this.No_Customer = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Rep_Msg').subscribe((res: string) => {
      this.Rep_Msg = res;
    });

  }

  ngOnInit() {
    let query = "SELECT * FROM `employee` WHERE `is_rep` = '1' AND `status`  = '1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.rep_list = data.data['list'];
        this.rep_list.unshift({ 'employee_no': '', 'name': 'اختر..', 'name_en': 'Select..' });
      });
  }

  search() {

    if (this.model['employee_no'] == '') {
      alert(this.Rep_Msg);
    }
    else if (this.model['payment_per'] == '') {
      alert(this.Payment_Msg);
    }
    else {
      this.total_payment = '0';
      let condition = "";

      if (this.model['from_date'] != undefined) {
        let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
          this.model['from_date'].getDate() + " 00:00:00";
        condition += " AND `invoice`.`invoice_date` >= '" + from_date + "'";
      }

      if (this.model['to_date'] != undefined) {
        let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
          this.model['to_date'].getDate() + " 23:59:59";
        condition += " AND `invoice`.`invoice_date` <= '" + to_date + "'";
      }

      let query = "SELECT `invoice`.*, `employee`.`name` FROM `invoice`, `employee`, `user` WHERE" +
        " `invoice`.`status` = '1' AND `invoice`.`created_by` = `user`.`user_name` AND" +
        " `employee`.`employee_no` = `user`.`employee_no` AND `invoice`.`rep_emp_no` = '"
        + this.model['employee_no'] + "'" + condition;

      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];
          this.dp.forEach(element => {

            element.invoice_date = (element.invoice_date).substring(0, 10);
            element.deliver_date = (element.deliver_date).substring(0, 10);

            //get customer name
            if (element.customer_no == '')
              element.customer_name = this.No_Customer;
            else {
              let query = "SELECT `customer_name` FROM `customer` WHERE `customer_no` = '" + element.customer_no + "'";
              obj = { cmd: 'getList', query: query };
              let customer;
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  customer = data.data['list'];
                  element.customer_name = customer[0].customer_name;
                });
            }

            //get invoice net total
            element.net_total = (Number(element.total) + Number(element.tax) - Number(element.discount)).toFixed(2);

            //get payment amount
            element.payment_amount = ((Number(element.net_total) * Number(this.model['payment_per'])) / 100).toFixed(2);

            //get payment method
            element.payment_method = '';
            query = "SELECT `payment_type`.`payment_type_name` FROM `inv_payment_method`, `payment_type` WHERE `inv_payment_method`.`invoice_no` = '" +
              element.invoice_no + "' AND `inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id` AND `inv_payment_method`.`status` != '0'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                let result = data.data['list'];
                result.forEach(element2 => {
                  if (element.payment_method != '')
                    element.payment_method += ' - ';
                  element.payment_method += element2.payment_type_name
                });
              });

            //calculate total payment
            this.total_payment = (Number(this.total_payment) + Number(element.payment_amount)).toFixed(2);
          });
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }
  }


  print() {

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
      
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2> ' + this.Rep_Acct_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Payment_Total + this.total_payment + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLSourceElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
